import { zfTranslations } from "./zf_translations";
import { zfUtils } from "./zf_utils";
import { zfc } from "./zfc_global";
import { zfcpc } from "./zfc_press";
export class zfcsc {
    static init() {
        try {
            if (($("[data-key='zfc-sidenav-cart-modal']").length == 0) && $(".zfc-sidenav-cart").length > 0) {
                $(".body-wrapper").append(`
				<div class="zfcacc-item">
					<div data-key="zfc-sidenav-cart-modal" data-callback="zfcsc.reinit"></div>
					<div class="zfcacc-accordion-section-content">
						<div class="zfcsc-header-wrapper">
							<h3 class="zfcsc-cart-header zfcui-prometo-medium">` +
                    zfTranslations.get("press.yourCollection") +
                    `</h3>
							` +
                    zfc.dividerHtml.replace("{{line_color}}", "grey-small") +
                    `
						</div>
						<div class="zfcui-cart-modal-body">
							<div class="zfcsc-cart-item-results-wrapper">
								<div class="zfcsc-items"></div>
							</div>
						</div>
						<div class="modal-footer">
							<div class="row zfcsc-cart-modal-footer-top">
								<div class="zfcsc-toc">
									<p>
									` +
                    zfTranslations.get("press.termsStart") +
                    `
										<a href="/termsofuse" target="_blank" class="zfcpd-terms-of-use-link" aria-label="opens in a new tab">
										` +
                    zfTranslations.get("press.termsOfUse") +
                    `
										</a> 
										` +
                    zfTranslations.get("press.termsEnd") +
                    `
									</p>
								</div>
								<div class="zfcsc-results-hits">
									<span class="result-hit-count zfcui-prometo-light"><span class="zfcsc-number">0</span>` +
                    zfTranslations.get("press.items") +
                    `</span>
								</div>
							</div>
							<div class="row zfcsc-cart-modal-footer-bottom">` +
                    zfUtils.handlebarsProcessTemplate(zfUtils.handlebarsCompile(zfc.btnPartHtml), {
                        target: "_blank",
                        label: zfTranslations.get("press.deleteAll"),
                        topDivClass: "delete-all-btn",
                        btnClass: "zfcui-btn-icon-left zfccta-button zfcpd-button zfcui-bg-red",
                        iconClass: "zfcui-icon-cross",
                    }) +
                    zfUtils.handlebarsProcessTemplate(zfUtils.handlebarsCompile(zfc.btnPartHtml), {
                        target: "_blank",
                        label: zfTranslations.get("press.downloadAsZip"),
                        topDivClass: "download-all-btn",
                        btnClass: "zfcui-btn-icon-left zfccta-button zfcpd-button",
                        iconClass: "zfcui-icon-download",
                    }) +
                    `</div>
						</div>
					</div>
				</div>`);
            }
            zfc.modalCallbacks[".zfcsc-header-wrapper"] = zfcsc.reinit;
        }
        catch (err) {
            console.log("Initalization failed: zfcsc.init() " + err.message);
        }
    }
    static reinit() {
        zfcsc.updatCartObject();
        zfcsc.setCartInfo();
        zfcsc.updateCart();
        $(".zfcui-modal .delete-all-btn")
            .off("click.zfcsc")
            .on("click.zfcsc", function () {
            zfcsc.clearCart();
        });
        $(".zfcui-modal .download-all-btn")
            .off("click.zfcsc")
            .on("click.zfcsc", function () {
            zfUtils.displaySpinner();
            var key;
            var imgList = [];
            for (key in zfcsc.CART) {
                if (zfcsc.CART[key].fsid.indexOf("pressData.media") != -1) {
                    imgList.push(zfcsc.CART[key].zipUrl);
                }
                else {
                    zfcpc.downloadPress(zfcsc.CART[key].fsid);
                }
            }
            if (imgList.length > 0)
                zfc.createZip("press_media.zip", imgList);
            zfUtils.hideSpinner();
        });
    }
    static clearCart() {
        for (const key in zfcsc.CART) {
            zfcsc.removeItemFromList(zfcsc.CART[key].uid, zfcsc.CART[key].fsid);
        }
    }
    static updatCartObject() {
        zfcsc.CART = {};
        var key;
        for (key in localStorage) {
            if (key.indexOf("cart_link_") == 0) {
                var newItem = JSON.parse(localStorage[key]);
                if (newItem.hasOwnProperty("fsid") && newItem.hasOwnProperty("uid"))
                    zfcsc.CART[key] = newItem;
            }
        }
    }
    static reloadCart() {
        zfcsc.updatCartObject();
        zfcsc.updateCart();
    }
    static updateCart() {
        $(".zfcsc-items").empty();
        var key, items = 0;
        for (key in zfcsc.CART) {
            items++;
            $(".zfcsc-items").append(zfcsc.createCartItem(zfcsc.CART[key]));
        }
        zfcsc.setCartInfo();
    }
    static createCartItem(data) {
        var category = data.category;
        var categoryType = zfcsc.getCategoryType(category);
        var panelTitle = data.title;
        var thumbnail = data.thumbnail;
        var cartItem = $("<div class='zfcsc-item cart-item clearfix border-bottom-gray-dots row'>" +
            "<img class='zfcsc-item-image' src='" +
            thumbnail +
            "' />" +
            "<div class='zfcsc-item-content'>" +
            "<span class='cart-item-clear-button zfcui-icon zfcui-icon-cross-thin'></span>" +
            "<div id='zfcsc-item'><span class='zfcui-icon zfcui-icon-" +
            categoryType +
            "'></span>" +
            category +
            "</div>" +
            "<p>" +
            panelTitle +
            "</p>" +
            "<p class='cart-item-meta'>" +
            panelTitle +
            "</p>" +
            "</div>" +
            "</div>" +
            "<span class='zfc-dotted-line zfc-dotted-line-grey'></span>");
        cartItem
            .find(".zfcsc-item-content .cart-item-clear-button")
            .off("click.zfcsc")
            .on("click.zfcsc", function () {
            zfcsc.removeItemFromList(data.uid, data.fsid);
        });
        zfcsc.getMetaInfo(cartItem.find(".cart-item-meta"), data.zipUrl);
        return cartItem;
    }
    static getCategoryType(category) {
        var categories = {
            Image: "camera",
            Audio: "audio",
            Video: "movie",
        };
        return categories[category] || "paper";
    }
    static removeItemFromList(uid, fsid) {
        $('.zfcpc-panel[data-uid="' + uid + '"]')
            .find(".zfcpc-cart-button")
            .removeClass("zfcpc-cart-active")
            .find(".zfcui-icon-cart-add")
            .removeClass("zfcui-icon-cart-remove");
        $("[data-uid]")
            .find(".zfcui-icon-cart-add")
            .removeClass("zfcui-icon-cart-remove");
        var deleteKey = "cart_link_" + fsid;
        localStorage.removeItem(deleteKey);
        zfcsc.updatCartObject();
        zfcsc.updateCart();
    }
    static getMetaInfo(item, url) {
        const request = $.ajax({
            type: "HEAD",
            url: url,
            success: function () {
                var responseType = request
                    .getResponseHeader("Content-type")
                    .split("/")[1];
                if (responseType != "pdf" &&
                    responseType != "jpeg" &&
                    responseType != "zip") {
                    item.html("");
                    item[0].metaFileSize = 0;
                }
                else {
                    item.html("Format: " +
                        request.getResponseHeader("Content-type").split("/")[1] +
                        ", " +
                        (parseFloat(request.getResponseHeader("Content-Length")) /
                            1000000).toFixed(2) +
                        "MB");
                    item[0].metaFileSize = parseInt(request.getResponseHeader("Content-Length"));
                }
            },
            error: function () {
                item.html("");
                item[0].metaFileSize = 0;
            },
        });
    }
    static setCartInfo() {
        var items = 0;
        for (var key in zfcsc.CART) {
            items++;
        }
        $(".zfcsn-cart-counter").text(items);
        $(".zfcsc-results-hits .zfcsc-number").text(items);
    }
}
zfcsc.CART = {};
